import { Box, Stack, TextField, Button, Tooltip, Typography, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory } from 'react-router-dom';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'


export default function TemplateConfiguration() {
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Template Configuration", "SubTab")?.editAccess
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [templateList, setTemplateList] = useState([]);
    const [delIDs, setdelIDs] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    useEffect(() => {
        getTemplateData()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getTemplateData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_TEMPLATE_CONFIGURATION + `?get_type=get`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setTemplateList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)}/>
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = templateList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        templateList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 's_no', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.api.getRowIndex(params.id) + 1}</Typography>)
            },
            {
                field: 'template_code', headerName: 'Template Code', flex: 0.25,
                renderCell: (params) => (params.row.template_code ? params.row.template_code?.length > 40 ?
                    <Tooltip placement="top" title={params.row.template_code}><Typography fontSize={'0.9vw'}>{params.row.template_code?.slice(0, 37) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.template_code}</Typography> : '-')
            },
            {
                field: 'template_name', headerName: 'Template Name', flex: 0.25,
                renderCell: (params) => (params.row.template_name ? params.row.template_name?.length > 40 ?
                    <Tooltip placement="top" title={params.row.template_name}><Typography fontSize={'0.9vw'}>{params.row.template_name?.slice(0, 37) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.template_name}</Typography> : '-')
            },
            {
                field: 'module_type', headerName: 'Apply To', flex: 0.25, align: 'center', headerAlign: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.module_type ? params?.row?.module_type : '-'}</Box>)
            },
            {
                field: 'count', headerName: 'No Of Service', flex: 0.25, align: 'center', headerAlign: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.count ? params?.row?.count : '0'}</Box>)

            },
            ...(commonDisable ? [
                {
                    field: 'action', headerName: 'Action', flex: 0.25, align: 'center', headerAlign: 'center',
                    renderCell: (params) => (
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                <CommonEditButton size="1.5vw" onClick={() => { history.push("/Settings/NewService/TemplateConfig/Add", { id: params.row?.id, TempName: params.row.template_name, TempCode: params.row.template_code, ModuleType: params.row.module_type, Isactive: params.row.is_active }) }} />
                            </Stack>
                        </Stack>)
                }
            ]:[])
        ]
        return (
            <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={templateList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([]);
        setdelIDs([]);
    }

    const deleteTemplate = () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.NEW_TEMPLATE_CONFIGURATION}?delete_type=template&template_id=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getTemplateData()
                        closeFilter();
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        {/* <Autocomplete
                            size='small'
                            options={department_category}
                            value={filtervendorCategory}
                            onChange={(event, newValue) => {
                                setFilterVendorCategory(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        /> */}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => { }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getTemplateData();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", }}>
                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '10vw', mt: "0.5vw", mb: "0.5vw" }} disabled={!commonDisable} onClick={() => { history.push("/Settings/NewService/TemplateConfig/Add") }}>ADD TEMPLATE</Button>
            </Box>
            <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteTemplate}
                />
                : null}
        </Box>
    )
}